import VuexTypes from '@/store/types/index';

const NotificationsTypes = VuexTypes.notifications;
export default {
  [NotificationsTypes.NOTIFICATIONS]: (state, { data, status }) => {
    state.notifications = { data, status };
  },
  [NotificationsTypes.NOTIFICATIONS_NEW]: (state, { data, status }) => {
    state.notificationsNew = { data, status };
  },
  [NotificationsTypes.NOTIFICATION_READ_UPDATE]: (state, { data, status }) => {
    state.notificationsReadUpdate = { data, status };
  },
};
